import { Group } from "@visx/group";
import { ClipPath } from "@visx/clip-path";
import { useMantineTheme } from "@mantine/core";

const SvgPlotWrapper = ({ 
    dimensions,
    children,
    setPlotTo100=false,
    id = 'none' 
    }) => {

    // If width and height are 
    const width = setPlotTo100 ? '100%' : dimensions.width;
    const height = setPlotTo100 ? '100%' : dimensions.height;

    const theme = useMantineTheme();

    if (!dimensions.width || !dimensions.height) return null;

    const idForInnerRect = id === 'none' ? 'inner-rect' : `inner-rect-${id}`;
    const idForSmallInnerRect = id === 'none' ? 'small-inner-rect' : `small-inner-rect-${id}`;

    return (
        <svg
            width={width}
            height={height}
            id='svg-plot'
            style={{ display: 'block', position: 'relative' }}
        >
            <Group left={dimensions.margins.left} top={dimensions.margins.top}>
                <defs>
                    <ClipPath id={idForInnerRect}>
                        <rect
                            x={0}
                            y={0}
                            width={dimensions.width - (dimensions.margins.left + dimensions.margins.right)}
                            height={dimensions.height - (dimensions.margins.top + dimensions.margins.bottom)}
                            fill = '#f5f5f5'
                        />
                    </ClipPath>
                    <ClipPath id={idForSmallInnerRect}>
                        <rect
                            x={0}
                            y={0}
                            width={100}
                            height={100}
                            rx={theme.radius.md}
                            ry={theme.radius.md}
                        />
                    </ClipPath>
                </defs>
                <rect
                    width={dimensions.width - (dimensions.margins.left + dimensions.margins.right)}
                    height={dimensions.height - (dimensions.margins.top + dimensions.margins.bottom)}
                    fill='#f5f5f5'
                />
                {/* <rect
                    width={dimensions.width - (dimensions.margins.left + dimensions.margins.right)}
                    height={dimensions.height - (dimensions.margins.top + dimensions.margins.bottom)}
                    fill="url(#backgroundPattern)"
                /> */}
                {children}
            </Group>
        </svg>
    )
}

export default SvgPlotWrapper;